// useNativeRoute to handle layout route issue
// https://github.com/nuxt/nuxt/issues/21340#issuecomment-1858900454
import { useRoute as useNativeRoute } from 'vue-router';

interface UseWorkspaceParams {
  builder?: boolean;
  isPublic?: boolean;
  tenantSlug?: string;
}

export const useWorkspace = (params: UseWorkspaceParams = {}) => {
  // Composables
  useZazos();
  const $route = useNativeRoute();
  const $rollbar = useRollbar();
  const theme = useTheme();
  const { $store, $auth, $analytics } = useNuxtApp();

  // Methods
  const loadWorkspaceData = () => {
    if (!$auth.user && !params.isPublic) return;

    if (params.isPublic) {
      params.tenantSlug = $route.params?.tenantSlug as string;
    }

    try {
      $store.dispatch('workspace/loadWorkspace', params);
    } catch (error) {
      $rollbar.error('Workspace load', error);
    }
  };

  const identifyUser = () => {
    $analytics.identify();
  };

  watch(() => $store.getters['workspace/primaryColor'], (primaryColor) => {
    theme.themes.value.light.colors.primary = primaryColor;
    theme.themes.value.dark.colors.primary = primaryColor;
  }, { immediate: true });

  onBeforeMount(() => {
    loadWorkspaceData();
    identifyUser();
  });

  onMounted(() => {
    $store.dispatch('features/fetchFeatures');

    Object.keys($route.query).filter(key => key.startsWith('feature_')).forEach((key) => {
      const flag = key.replace('feature_', '');
      const value = $route.query[key] === 'true';
      $store.dispatch('features/toggleFeature', { flag, value });
    });
  });
};
